import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=518c6f80&"
import script from "./HowItWorks.vue?vue&type=script&lang=js&"
export * from "./HowItWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports